import React from "react";
import MDBox from "components/MDBox";
import GroupTabButton from "components/GroupTabButton/GroupTabButton";
import Grid from "@mui/material/Grid";
import {
  WorkshopTabEnum,
  WorkshopTabsData,
} from "data/my-development/MyDevelopment.data";
import WorkshopAvailableTable from "components/WorkshopAvailableTable/WorkshopAvailableTable";
import WorkshopRegisteredTable from "components/WorkshopRegisteredTable/WorkshopRegisteredTable";
import WorkshopAttendedTable from "components/WorkshopAttendedTable/WorkshopAttendedTable";
import { Loading } from "shared/components/ui/Loading";

const TabWorkshop = ({ ...rest }) => {
  const {
    tabWorkshop,
    dataTableAvailable,
    dataTableRegistered,
    dataTableAttended,
    isLoadingData,
    onClickTab,
    onCheckSchedule,
  } = rest;
  // console.log(tabWorkshop);

  const propertiesWorkshopAvailableTable = {
    data: dataTableAvailable,
    onCheckSchedule,
  };

  const propertiesWorkshopRegisteredTable = {
    data: dataTableRegistered,
    onCheckSchedule,
  };

  const propertiesWorkshopAttendedTable = {
    data: dataTableAttended,
  };

  return (
    <div className="tab-workshop">
      <MDBox className="tab-workshop__container">
        <Grid
          className={"tab-workshop__group-tab"}
          container
          alignItems="center"
          gap={1}
        >
          {WorkshopTabsData.tabs.map((item, index) => {
            const propertiesGroupTabButton = {
              title: item.title,
              isActive: tabWorkshop === item.title,
              onClick: () => {
                onClickTab(item.title);
              },
            };

            return (
              <GroupTabButton
                key={index}
                className="tab-workshop__group-tab__item"
                {...propertiesGroupTabButton}
              />
            );
          })}
        </Grid>

        {isLoadingData ? (
          <Loading style={{ width: 300, height: 200, margin: "10% auto" }} />
        ) : (
          <MDBox className="tab-workshop__content_container">
            {tabWorkshop === WorkshopTabEnum.Available && (
              <WorkshopAvailableTable {...propertiesWorkshopAvailableTable} />
            )}
            {tabWorkshop === WorkshopTabEnum.Registered && (
              <WorkshopRegisteredTable {...propertiesWorkshopRegisteredTable} />
            )}
            {tabWorkshop === WorkshopTabEnum.Attended && (
              <WorkshopAttendedTable {...propertiesWorkshopAttendedTable} />
            )}
          </MDBox>
        )}
      </MDBox>
    </div>
  );
};

export default TabWorkshop;
